import React, { useState, useEffect, useContext } from 'react'
import { db, storage } from '../../Firebase/firebase'
import { AuthContext } from '../../Context/AuthContext/AuthContext'

import './UserAboutForm.css'
import UserBio from '../UserSettingsBio/UserBio'
import UserPassword from '../UserSettingsPassword/UserPassword'
import { ThemeContext } from '../../Context/ThemeContext/ThemeContext'

const UserAboutForm = () => {
  const { isLight } = useContext(ThemeContext)
  const { currentUser } = useContext(AuthContext)
  
  const [img,setImg] = useState('')
  const [bio, setBio] = useState('')
  const [imgPath, setImgPath] = useState(null)
  const [imgURL, setImgURL] = useState(null)
  const [progress, setProgress] = useState(0)

  const handleImageUpload = e => {
    if(e.target.files[0]){
      setImgPath(e.target.files[0])
    }
  }

  const handleImgSubmit = e => {
    e.preventDefault()
    const uploadImg = storage.ref(`images/${imgPath.name}`).put(imgPath)

    uploadImg.on(
      'state_changed',
      (snapshot) => {
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress)
      },
      (error) => {
        alert(error.message)
      },
      () => {
        uploadImg.snapshot.ref.getDownloadURL()
          .then(downloadURL => {
            setImgURL(downloadURL)
            db.collection('users').doc(currentUser.uid).update(
              {
                profilePic: downloadURL
              }
            )
            currentUser.updateProfile(
              {
                photoURL: downloadURL
              }
            )
          })
      }
    )
  }

  const handleBioSubmit = e => {
    e.preventDefault()
    db.collection('users').doc(currentUser.uid).update(
      {
        bio
      }
    )
  }

  //*currentuser looks like an async function so at the start it wasnt able, thats why the dependency so that whenever it would change it would call the use effect
  useEffect(() => {
    if(currentUser !== ''){

      db.collection('users').doc(currentUser.uid).onSnapshot(snapshot => {
        console.log(snapshot.data())
        setImg(snapshot.data().profilePic)
        setBio(snapshot.data().bio)
        
      })
    }
  }, [currentUser])

  return (
    <section className={`user-about-form ${isLight ? "" : "dark"}`}>
      <form className="user-about-form__profile" onSubmit={handleImgSubmit}>
        <img src={img} alt="user" className="user-about-profile__img"/>
        <input type="file" onChange={handleImageUpload} required/>
        <button className="user-about-form__btn" type="submit">Submit!</button>
      </form>

      <section className="user-about-form-bio">
        <div className="user-bio">
          <form className="user-bio__form" onSubmit={handleBioSubmit}>
            <label>Bio</label>
            <textarea className="user-bio__textarea" value={bio} onChange={e => setBio(e.target.value)} />
            <button className="user-bio__btn" type="submit">Change</button>
          </form>
        </div>
      </section>

      <UserPassword />
    </section>
  )
}

export default UserAboutForm
